export const environment = {
  debug: true,
  hmr: false,
  production: false,
  version: require("../../scripts/package.json").version,
};
